export const StaticFilePaths = {
  PreviewImage: "assets/images/client/preview-image.png"
}
